import { CloseSVG } from 'common/assets';
import { themedStyled } from 'common/styles/styletron.theme';
import Text from 'components/elements/text';
import { Action } from 'legacy-modules/styles';
import * as React from 'react';
import { StyleObject } from 'styletron-standard';

interface Props {
  onClose: () => void;
  title?: string;
  subtitle?: string;
  $style?: StyleObject | any;
}

export default function DrawerHeader(props: Props) {
  const { onClose, title, subtitle, $style } = props;
  return (
    <HeaderContainer $style={$style}>
      <LeftContainer>
        {!!title && <Text variant="HeadingSmall">{title}</Text>}
        {!!subtitle && (
          <>
            <div style={{ marginTop: 4 }} />
            <Text variant="body3Regular">{subtitle}</Text>
          </>
        )}
      </LeftContainer>
      <RightContainer>
        <Action onClick={onClose}>
          <CloseSVG />
        </Action>
      </RightContainer>
    </HeaderContainer>
  );
}

const HeaderContainer = themedStyled('div', ({ $theme }) => ({
  padding: '20px',
  // backgroundColor: $theme.colors.skyLighter,
  display: 'flex',
  justifyContent: 'space-between',
}));

const LeftContainer = themedStyled('div', ({ $theme }) => ({}));

const RightContainer = themedStyled('div', ({ $theme }) => ({}));
